import { DetailsPanelType } from "PFApp/booking/components/details_panel";
import useBookingModulePermissions from "PFApp/use_booking_module_permissions";
import { useIsExternalUsage } from "PFCore/hooks/queries/bookings/use_is_external_usage";
import { useCallback } from "react";

export const useCanOpenDetailsPanelOfType = () => {
  const { isEnabled: isBMEnabled } = useBookingModulePermissions();
  const isExternal = useIsExternalUsage();

  const canOpenDetailsPanelOfType = useCallback(
    (type: DetailsPanelType) => {
      if (!isBMEnabled) {
        return false;
      }
      if (type === "profile") {
        return !isExternal;
      } else {
        return true;
      }
    },
    [isBMEnabled, isExternal]
  );

  return canOpenDetailsPanelOfType;
};
